import createSvgIcon from '@icons/utils/create-svg-icon';
import ChevronLeftSvg from './svg/chevron-left.svg';

const ChevronLeftIcon = createSvgIcon(ChevronLeftSvg);

export default ChevronLeftIcon;
